<template>
  <section>
    <p class="font-medium">Additional information for {{ member.displayName }}</p>
    <div class="mt-2 p-4 border bg-gray-100 rounded  flex flex-col md:flex-row flex-wrap">
      <question
        v-for="(question, idx) in questions"
        :key="idx"
        :id="`${member.uuid}-${question.id}`"
        v-model="$v.additionalInfo[question.type].$model"
        :options="question.options"
        :validationError="
          $v.additionalInfo[question.type].$dirty
          && $v.additionalInfo[question.type].$invalid
            ? 'This question is required.'
            : null
        "
      >
        {{ question.description }}
      </question>
      <div class="sm:w-1/2 text-sm p-2">
        <h3 class="font-medium">Risk Appetite Definitions</h3>
        <dl class="mt-2">
          <dt>Low Risk Tolerance</dt>
          <!-- eslint-disable-next-line max-len -->
          <dd class="text-gray-600 leading-4">minimising investment losses is paramount.  Stable returns are preferred even if this means long term growth is lower than would be possible with more ambitious investments</dd>
          <dt>Modest Risk Tolerance</dt>
          <!-- eslint-disable-next-line max-len -->
          <dd class="text-gray-600 leading-4">investment losses are acceptable from time to time in order to achieve returns that are at least above inflation over the medium term</dd>
          <dt>High Risk Tolerance</dt>
          <!-- eslint-disable-next-line max-len -->
          <dd class="text-gray-600 leading-4">short term investment losses are accepted and expected as the primary goal is to maximise returns over the long term</dd>
        </dl>
      </div>
    </div>
    <div class="mt-2 text-right">
      <m-button @click="handleSave">
        Save
      </m-button>
    </div>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import Question from './question/question.vue';

const questions = [
  {
    id: 'work-status',
    type: 'currentWorkStatus',
    description: 'Select the work status for the member',
    options: [
      'in paid full-time employment',
      'in paid regular (but not full time) employment',
      'in paid occasional work',
      'not undertaking paid work',
    ],
  },
  {
    id: 'contribution-plans',
    type: 'contributionPlans',
    description: 'Select the contribution plans for the member',
    options: [
      'making regular contributions every year',
      'making contributions occasionally but not necessarily every year',
      'no longer making contributions',
    ],
  },
  {
    id: 'income-needs',
    type: 'incomeNeeds',
    description: 'Select the current income needs from the Fund',
    options: [
      'currently receiving a pension',
      'not receiving a pension but expects to start one within 5 years',
      'not receiving a pension and one is unlikely to start in the near term',
    ],
  },
  {
    id: 'long-term-income-needs',
    type: 'longTermIncomeNeeds',
    description: 'Select the long term income needs for the Fund',
    options: [
      'will depend on income from the Fund in retirement',
      'will supplement income in retirement with income from the Fund',
      'unlikely to depend on income from the Fund in retirement',
    ],
  },
  {
    id: 'risk-appetite',
    type: 'riskAppetite',
    description: 'Select the risk appetite for the member',
    options: [
      'low risk tolerance',
      'modest risk tolerance',
      'high risk tolerance',
    ],
  },
];

export default {
  name: 'member-info',
  components: {
    Question,
  },
  mixins: [ToolkitMixin],
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      questions,
      additionalInfo: {
        currentWorkStatus: {
          value: '',
          other: '',
        },
        contributionPlans: {
          value: '',
          other: '',
        },
        incomeNeeds: {
          value: '',
          other: '',
        },
        longTermIncomeNeeds: {
          value: '',
          other: '',
        },
        riskAppetite: {
          value: '',
          other: '',
        },
      },
    };
  },
  methods: {
    updateMember() {
      const { members } = this.getItem;
      const memberIdx = members.findIndex(item => item.displayName === this.member.displayName);
      members.splice(memberIdx, 1, {
        ...this.member,
        additionalInfo: {
          ...this.member.additionalInfo,
          ...this.additionalInfo,
        },
      });
      this.setItem({
        members,
      });
    },
    handleSave() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.updateMember();
      this.$emit('close');
    },
  },
  mounted() {
    this.additionalInfo = this.member.additionalInfo;
  },
  validations: {
    additionalInfo: {
      currentWorkStatus: {
        value: {
          required,
        },
        // other: '',
      },
      contributionPlans: {
        value: {
          required,
        },
        // other: '',
      },
      incomeNeeds: {
        value: {
          required,
        },
        // other: '',
      },
      longTermIncomeNeeds: {
        value: {
          required,
        },
        // other: '',
      },
      riskAppetite: {
        value: {
          required,
        },
        // other: '',
      },
    },
  },
};
</script>
